import { PharmacyTheme } from '../PharmacyThemeInterface';
import pic from './assets/veritas_slider3.jpg';

export const thirdTestCustomisations: Partial<PharmacyTheme> = {
  panoramaPic: pic,
};
